module.exports = __webpack_public_path__ + "img/social_responsibility_book.34c23dd4.jpg";